<template>
  <div :class="['wrap',!$route.meta.hasNoHeader?'has-header':'']">
    <page-header ></page-header>
    
    
    <router-view></router-view>
    <page-footer v-if="$route.meta.hasFooter"></page-footer>
  </div>
</template>
<script>
export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
</style>
